import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';

const ExpectationsSection = ({ 
  title, 
  subtitle,
  expectations = [], 
  customClass = '',
  backgroundColor = 'bg-white' 
}) => {
  return (
    <section className={`md:mt-[-200px] md:pt-[200px] py-8 md:py-16 px-4 ${backgroundColor} ${customClass}`}>
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left column - Title */}
          <div className="flex flex-col justify-center items-center lg:items-start">
            <h2 className="text-3xl md:text-4xl font-bold mb-2">
              <span className="text-green-500">{parse(title)}</span>
            </h2>
            {subtitle && (
              <h2 className="text-3xl md:text-4xl font-light text-gray-900">
                {parse(subtitle)}
              </h2>
            )}
          </div>
          
          {/* Right column - Expectations list */}
          <div className="flex flex-col items-start">
            {expectations.map((expectation, index) => (
              <div key={index} className="flex flex-row justify-start items-start mb-8 w-full">
                <div className="flex-shrink-0 w-6 h-6 mr-6">
                  <svg className="w-6 h-6 text-slate-500" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">
                    {parse(expectation.title)}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {parse(expectation.description)}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

ExpectationsSection.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  expectations: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired
  })).isRequired,
  customClass: PropTypes.string,
  backgroundColor: PropTypes.string
};

export default ExpectationsSection;